export default __webpack_public_path__ + "static/media/Purple haze_primary.7c635053.jpg";